import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, Input, Select, Button, message } from 'antd';
import { withOnFocus } from '../../../../../components/HOC';
import AddressSearchBox from '../../../../../components/AddressSearchBox/AddressSearchBox';
import { createCustomer, updateCustomer } from '../CustomerAction';
import { orgIdSelector } from '../../../OrganisationSelectors';
import { loadingCustomersSelector } from '../CustomerSelectors';
import { MSG_SAVE_SUCCESS, MSG_ERROR } from '../../../../../constants';
import explanations from '../data/explanations.json';

const FormItem = Form.Item;
const { Option } = Select;

const categoryPresets = ['Finance', 'Information Technology', 'Engineering', 'Call Centre', 'Human Resource', 'Sales'];

class CustomerEditModal extends PureComponent {
  constructor(props) {
    super(props);
    this.SelectWithOnFocus = withOnFocus(Select, props.onExplanationChange);
    this.InputWithOnFocus = withOnFocus(Input, props.onExplanationChange);
    this.AddressSearchBoxWithOnFocus = withOnFocus(AddressSearchBox, props.onExplanationChange);
  }

  onSubmit = e => {
    e.preventDefault();
    const { form, orgId, customerInfo, createCustomer, updateCustomer, close } = this.props;
    form.validateFields(async (err, fieldsValue) => {
      if (!err) {
        const values = Object.keys(fieldsValue).reduce((acc, key) => {
          if (fieldsValue[key]) {
            if (typeof fieldsValue[key] === 'string') {
              acc[key] = fieldsValue[key].trim();
            } else if (typeof fieldsValue[key] === 'object') {
              acc[key] = JSON.stringify(fieldsValue[key]);
            } else {
              acc[key] = fieldsValue[key];
            }
          }
          return acc;
        }, {});
        try {
          if (customerInfo) {
            const { customerId } = customerInfo;
            await updateCustomer(orgId, customerId, values);
          } else {
            await createCustomer(orgId, values);
          }
          message.success(MSG_SAVE_SUCCESS);
          close();
        } catch (err) {
          message.error(MSG_ERROR);
        }
      }
    });
  };

  render() {
    const { InputWithOnFocus, SelectWithOnFocus, AddressSearchBoxWithOnFocus } = this;
    const { form, customerInfo = {}, loading } = this.props;
    const { getFieldDecorator } = form;
    let initialCategory = [];
    if (customerInfo.category) {
      try {
        initialCategory = JSON.parse(customerInfo.category);
      } catch {
        initialCategory = customerInfo.category;
      }
    }
    const categoryOptions = categoryPresets.map(categoryName => (
      <Option key={categoryName} value={categoryName}>
        {categoryName}
      </Option>
    ));

    return (
      <Form>
        <FormItem label="Name">
          {getFieldDecorator('name', {
            initialValue: customerInfo.name,
            rules: [{ required: true, message: 'Please input the name.' }]
          })(
            <InputWithOnFocus
              placeholder="Name"
              disabled={loading}
              spellCheck={false}
              explanation={explanations.name}
            />
          )}
        </FormItem>
        <FormItem label="Category">
          {getFieldDecorator('category', {
            initialValue: initialCategory
          })(
            <SelectWithOnFocus
              mode="tags"
              placeholder="Category"
              disabled={loading}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              tokenSeparators={[',']}
              explanation={explanations.category}
            >
              {categoryOptions}
            </SelectWithOnFocus>
          )}
        </FormItem>
        <FormItem label="Contact Person">
          {getFieldDecorator('contactPerson', {
            initialValue: customerInfo.contactPerson
          })(<InputWithOnFocus placeholder="Contact Person" disabled={loading} spellCheck={false} />)}
        </FormItem>
        <Row gutter={20}>
          <Col span={12}>
            <FormItem label="Email">
              {getFieldDecorator('email', {
                initialValue: customerInfo.email,
                validateTrigger: 'onBlur',
                rules: [
                  {
                    type: 'email',
                    message: 'Please input an valid email.'
                  },
                  {
                    required: true,
                    message: 'Please input the email.'
                  }
                ]
              })(
                <InputWithOnFocus
                  placeholder="Email"
                  disabled={loading}
                  spellCheck={false}
                  explanation={explanations.email}
                />
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Phone">
              {getFieldDecorator('phone', {
                initialValue: customerInfo.phone
              })(<InputWithOnFocus placeholder="Phone" disabled={loading} explanation={explanations.phone} />)}
            </FormItem>
          </Col>
          <Col span={16}>
            <FormItem label="Address">
              {getFieldDecorator('address', {
                initialValue: customerInfo.address
              })(
                <AddressSearchBoxWithOnFocus
                  placeholder="Address"
                  disabled={loading}
                  spellCheck={false}
                  explanation={explanations.address}
                />
              )}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem label="Unit/Suite/Floor">
              {getFieldDecorator('additionalAddressInformation', {
                initialValue: customerInfo.additionalAddressInformation
              })(
                <InputWithOnFocus
                  placeholder="Unit/Suite/Floor"
                  disabled={loading}
                  explanation={explanations.additionalAddressInformation}
                />
              )}
            </FormItem>
          </Col>
        </Row>
        <FormItem label="Website">
          {getFieldDecorator('website', {
            initialValue: customerInfo.website
          })(<InputWithOnFocus placeholder="Website" disabled={loading} />)}
        </FormItem>
        <FormItem>
          <Button type="primary" block loading={loading} onClick={this.onSubmit}>
            {loading ? 'Saving' : 'Save'}
          </Button>
        </FormItem>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  orgId: orgIdSelector(state),
  loading: loadingCustomersSelector(state)
});

const mapDispatchToProps = { createCustomer, updateCustomer };

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(CustomerEditModal));
